
import { Component, Mixins, Ref } from 'vue-property-decorator'
import PaginationMixin from '@/mixins/pagination-mixin'
import NotificationDialog from './NotificationDialog.vue'
import { handlerClick } from './notify_handler'
import { useNotifyStore } from '@/store/notify'
import { NotifyListOutput } from '@/api/swagger'

const notifyStore = useNotifyStore()

@Component({
  components: {
    NotificationDialog,
  },
})
export default class extends Mixins(PaginationMixin) {
  @Ref('NotificationDialog')
  refNotificationDialog!: HTMLFormElement

  private notifyStore = notifyStore
  loading = false
  dataSource: NotifyListOutput[] = []
  ws: WebSocket | null = null
  async handler(notify: NotifyListOutput) {
    await this.$http.post('/api/Notify/Readed', {
      ids: [String(notify.id || '')],
    })
    notify.readed = true
    this.notifyStore.updateUnreadCount()
    const { redirect } = await handlerClick(notify)

    if (redirect) {
      await this.$router.push(redirect)
    }
  }

  onChange() {
    this.load()
  }

  async load() {
    this.loading = true
    const res = await this.$http.get('/api/Notify/PageLite', {
      Page: this.pagination.JSON.current,
      PageSize: 5,
    })
    this.dataSource = res.data.list || []
    this.pagination.update(res.data)
    this.loading = false
  }

  // 打开全部消息
  openAll() {
    this.refNotificationDialog.open()
  }

  created() {
    this.pagination.updateDefaults({
      current: this.pagination.defaults.current,
      pageSize: 5,
    })
    if (location.pathname.startsWith('/fire')) {
      this.connect()
    }
  }

  mounted() {
    if (location.pathname.startsWith('/fire')) {
      this.notifyStore.updateUnreadCount()
    }
  }

  destroyed() {
    this.ws?.close()
  }

  connect() {
    this.$http.get('/api/Websocket/PreConnect').then((res) => {
      const { data } = res
      if (data.server) {
        this.ws = new WebSocket(data.server)
        this.ws.addEventListener('message', (e) => {
          const data = JSON.parse(e.data)
          if (data && data.Type === 'MsgUnreadCount') {
            if (data.Payload) {
              this.notifyStore.UPDATE_UNREAD_COUNT(data.Payload?.Count)
              this.$notification.open({
                message: data.Payload?.Title,
                description: data.Payload?.Msg,
                top: '80px',
              })
            }
          }
        })
        this.notifyStore.UPDATE_WEBSOCKET_ID(data?.websocketId)
      }
    })
  }
}
